import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '../../../ui/Form';
import { CustomFormField } from '../../../app/CustomFormField';
import { Button } from '../../../ui/Button';
import { Spinner } from '../../../app/Spinner';
import { useContactCreateForm } from '@hero/web-hooks';

export interface ContactFormProps {
  isLoading?: boolean;
  /** Form hook from useContactCreateForm(); required. */
  formHook: ReturnType<typeof useContactCreateForm>;
  /** Hide submit button (for use with ModalForm) */
  hideSubmitButton?: boolean;
}

export function ContactForm({
  isLoading = false,
  hideSubmitButton = false,
  formHook,
}: ContactFormProps) {
  const { t } = useTranslation(['m-contact', 'c-main']);

  return (
    <Form {...formHook}>
      <div className="space-y-4">
        <CustomFormField
          control={formHook.control}
          name="name"
          filedType="input"
          placeholder={t('m-contact:form.full_name.placeholder')}
          label={t('m-contact:form.full_name.title')}
        />

        <CustomFormField
          control={formHook.control}
          name="phone"
          filedType="phone-input"
          placeholder={t('m-contact:form.phone_number.placeholder')}
          label={t('m-contact:form.phone_number.title')}
        />

        <CustomFormField
          control={formHook.control}
          name="email"
          filedType="input"
          placeholder={t('m-contact:form.email.placeholder')}
          label={t('m-contact:form.email.title')}
        />

        {!hideSubmitButton && (
          <Button
            type="button"
            className="w-full"
            disabled={isLoading}
            onClick={() => formHook.onValidSubmit()}>
            {isLoading ? (
              <>
                <Spinner className="mr-2" />
                <span>{t('c-main:async_operations.creating')}</span>
              </>
            ) : (
              <span>{t('c-main:crud_buttons.create')}</span>
            )}
          </Button>
        )}
      </div>
    </Form>
  );
}
